import type { DetailSection, Point, ScreenMeta, StudyDesignItem } from '../types/study';

export const results = {
  jascayd: -114.7,
  placebo: -183.5,
  difference: 68.8,
  backgroundAntifibroticPct: 77.7,
};

// Schematic curves connecting baseline to the reported Week 52 values.
export const placeboTrajectory: Point[] = [
  { week: 0, ml: 0 },
  { week: 13, ml: -52 },
  { week: 26, ml: -98 },
  { week: 39, ml: -142 },
  { week: 52, ml: -183.5 },
];

export const jascaydTrajectory: Point[] = [
  { week: 0, ml: 0 },
  { week: 13, ml: -34 },
  { week: 26, ml: -63 },
  { week: 39, ml: -90 },
  { week: 52, ml: -114.7 },
];

export const studyDesign: StudyDesignItem[] = [
  { label: 'Duration', value: '52 weeks' },
  { label: 'Endpoint', value: 'Change in FVC' },
  { label: 'Treatment', value: 'JASCAYD 18 mg vs placebo' },
];

export const mechanismSteps: string[] = [
  'Fibrotic & inflammatory signalling',
  'Fibroblast activity',
  'Progressive fibrosis',
];

export const screens: ScreenMeta[] = [
  { id: 'hook', label: 'Introduction', footnote: 'Intended for healthcare professionals.' },
  {
    id: 'context',
    label: 'Study context',
    footnote: 'IPF, idiopathic pulmonary fibrosis. FVC, forced vital capacity.',
  },
  {
    id: 'prediction',
    label: 'Your estimate',
    footnote: 'Your estimate stays on this device. It is not stored or shared.',
  },
  {
    id: 'result',
    label: 'Result',
    footnote:
      'Adjusted mean change from baseline in FVC at Week 52. Curves are schematic and connect the reported Week 52 values.',
  },
  {
    id: 'population',
    label: 'Population',
    footnote: 'There was no head-to-head comparison with nintedanib or pirfenidone.',
  },
  {
    id: 'mechanism',
    label: 'Mechanism',
    footnote: 'This mechanism diagram is simplified and for illustration only.',
  },
  {
    id: 'close',
    label: 'Summary',
    footnote: 'Please refer to the full Prescribing Information before prescribing.',
  },
];

export const studyDetails: DetailSection[] = [
  {
    title: 'Design',
    body: 'Phase 3, randomised, double-blind, placebo-controlled study over 52 weeks.',
  },
  {
    title: 'Population',
    body: 'Adults with idiopathic pulmonary fibrosis, with or without background nintedanib or pirfenidone.',
  },
  {
    title: 'Treatment arms',
    body: 'JASCAYD 18 mg twice daily, JASCAYD 9 mg twice daily, or placebo.',
  },
  {
    title: 'Primary endpoint',
    body: 'Absolute change from baseline in forced vital capacity (FVC, mL) at Week 52.',
  },
  {
    title: 'Background therapy',
    body: '77.7% of patients were receiving nintedanib or pirfenidone at baseline.',
  },
  {
    title: 'Key result',
    body: 'Adjusted mean change in FVC at Week 52: −114.7 mL with JASCAYD 18 mg vs −183.5 mL with placebo. Adjusted difference: 68.8 mL.',
  },
  {
    title: 'Important',
    body: 'FIBRONEER-IPF compared JASCAYD with placebo. It was not designed to compare JASCAYD with nintedanib or pirfenidone, and no superiority over these therapies is implied.',
  },
];

export const reference = 'Richeldi L, et al. Nerandomilast in patients with idiopathic pulmonary fibrosis. N Engl J Med. 2025.';
